const breakpoints = {
    xsmall: 320,
    small: 420,
    medium: 768,
    large: 1024,
    xlarge: process.env.BRAND === 'northstar' ? 1440 : 1280,
    xxl: 2560,
};
export default breakpoints;
//# sourceMappingURL=breakpoints.js.map